import type { FlagCategory } from '@generated/graphql';
import type {
  FlagGlossaryFilterValues,
  FlagGlossaryRowView,
} from './flagGlossary.types';

export type FlagGlossaryCategoryOption = {
  value: FlagCategory;
  label: string;
};

export const buildFlagGlossaryCategoryOptions = (
  rows: FlagGlossaryRowView[],
): FlagGlossaryCategoryOption[] => {
  const seen = new Map<FlagCategory, string>();
  for (const row of rows) {
    if (!seen.has(row.entry.category)) {
      seen.set(row.entry.category, row.categoryLabel);
    }
  }
  return [...seen.entries()]
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

export const filterFlagGlossaryRows = (
  rows: FlagGlossaryRowView[],
  filters: FlagGlossaryFilterValues,
): FlagGlossaryRowView[] => {
  const query = filters.search.trim().toLowerCase();

  return rows.filter((row) => {
    if (
      filters.severityTab !== 'ALL' &&
      row.entry.actual.priority !== filters.severityTab
    ) {
      return false;
    }

    if (
      filters.categoryFilter !== 'any' &&
      row.entry.category !== filters.categoryFilter
    ) {
      return false;
    }

    if (!query) {
      return true;
    }

    const haystack = [
      row.flagName,
      row.entry.flagType,
      row.description,
      row.exampleTrigger,
    ]
      .join(' ')
      .toLowerCase();

    return haystack.includes(query);
  });
};
